import validate from "/vercel/path0/node_modules/.pnpm/nuxt@4.2.1_@libsql+client@0.15.15_@parcel+watcher@2.5.1_@types+node@24.10.0_@vercel+blo_d6f82ecef7735b0ae36305d0e860f4a4/node_modules/nuxt/dist/pages/runtime/validate.js";
import docs_45version_45global from "/vercel/path0/app/middleware/docs-version.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@4.2.1_@libsql+client@0.15.15_@parcel+watcher@2.5.1_@types+node@24.10.0_@vercel+blo_d6f82ecef7735b0ae36305d0e860f4a4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  docs_45version_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/app/middleware/auth.ts"),
  guest: () => import("/vercel/path0/app/middleware/guest.ts")
}